// extracted by mini-css-extract-plugin
export default {"list":"InfiniteScroll-module__list__VWRgs","loader":"InfiniteScroll-module__loader__2Q1S5"};